import { render, staticRenderFns } from "./PendingAssignList.vue?vue&type=template&id=360c0372&scoped=true"
import script from "./PendingAssignList.vue?vue&type=script&lang=js"
export * from "./PendingAssignList.vue?vue&type=script&lang=js"
import style0 from "./PendingAssignList.vue?vue&type=style&index=0&id=360c0372&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c0372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360c0372')) {
      api.createRecord('360c0372', component.options)
    } else {
      api.reload('360c0372', component.options)
    }
    module.hot.accept("./PendingAssignList.vue?vue&type=template&id=360c0372&scoped=true", function () {
      api.rerender('360c0372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/center/PendingAssignList.vue"
export default component.exports